import campaignConstants from '../constants/campaign';

const initialState = {
  data: [],
  detail: null,
  selected: null,
  manualQueries: []
}

export default function campaign (state=initialState, action) {
  switch (action.type) {
    case campaignConstants.CREATE_CAMPAIGN:
      return {
        ...state,
        detail: action.detail
      };
    case campaignConstants.DESTROY_CAMPAIGN:
      const data = [...state.data];
      const campaignToArchive = data.findIndex((campaign) => campaign.apikey === action.apikey);
      data[campaignToArchive].status = 'archived';
      return {
        ...state,
        data
      };
    case campaignConstants.LIST_CAMPAIGN:
      return {
        ...state,
        data: action.data
      };
    case campaignConstants.RETRIEVE_CAMPAIGN:
      return {
        ...state,
        detail: action.detail
      };
    case campaignConstants.UPDATE_CAMPAIGN:
      return {
        ...state,
        detail: action.detail
      };
    case campaignConstants.CLEAR_CAMPAIGN:
      return {
        ...state,
        data: [],
        detail: null
      };
    case campaignConstants.RECEIVE_MANUAL_QUERIES:
      return {
        ...state,
        manualQueries: action.queries
      }
    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/campaign.js
 **/